module.exports = "<app-pagesnavbar-cmp></app-pagesnavbar-cmp>\n<router-outlet></router-outlet>"